import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ToastService } from 'src/app/services/toast.service';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import User from 'src/app/interfaces/User';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss'],
})
export class InviteComponent implements OnInit, OnDestroy {
  emails = [{ value: null }, { value: null }, { value: null }];
  inviteCopied = false;
  subscriptions: Subscription = new Subscription();
  currentUser: User;

  constructor(
    private location: Location,
    private toastService: ToastService,
    private loadingService: LoadingService,
    private notificationsService: NotificationsService,
    private userService: UserService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('referral_view');
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  addEmail() {
    if (this.emails.every(email => email.value)) {
      this.emails.push({ value: null });
    }
  }
  validateEmail(email) {
    if (!email) return false;

    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if(email.match(mailformat)) return true
    return false;
  }
  checkValid() {
    // no fields have value
    if (this.emails.every(email => !email.value)) return false
    // fields that have value are valid
    if (this.emails.every(email => !email.value || email.value && this.validateEmail(email.value))) return true
  }

  invite() {
    this.loadingService.startLoading();
    let inviteCount = 0;
    this.emails.forEach((e) => {
      if (!!e.value) {
        inviteCount++;
      }
    });
    this.analyticsService.event('referral_send', { emails: inviteCount });
    this.notificationsService.inviteColleagues(this.emails, this.currentUser.displayName).subscribe(
      (r) => {
        this.loadingService.stopLoading();
        this.toastService.setToast('<b>Success!</b> We’ve sent your colleagues invites!');
        this.location.back();
      },
      (e) => {
        this.loadingService.stopLoading();
        console.error(e);
      }
    );
  }

  submit() {
    this.loadingService.startLoading();
    setTimeout(() => {
      this.loadingService.stopLoading();
      this.toastService.setToast('<p class="mbn txt-c">Yay! Your invites have been sent!</p>');
      this.location.back();
    }, 2000);
  }
  confirm() {
    this.location.back();
  }

  getInviteLink() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = 'https://community.oceanvisions.org/m/signup';
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.inviteCopied = true;
  }
}
